/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { combineReducers } from '@reduxjs/toolkit';
import registrationForm from './contractorRegistrationForm';
import clientRegistrationForm from './clientRegistrationForm';

const rootReducer = combineReducers({
    contractorRegistration: registrationForm,
    clientRegistration: clientRegistrationForm,
});

export default rootReducer;
